import React from 'react'
import { useTranslation } from 'react-i18next'

import Footer from '../../components/Footer'
import withLang from '../../withLang'

function GetReadyPage(props) {
  const { t } = useTranslation()

  return (
    <main>
      <div className="container">
        <div className="home-top text-center pt-4">
          <div className="container">
            <div onClick={() => props.history.push('/start')}>
              <img src={require(`../../assets/images/logo.png`)} alt="Guerin" />
            </div>
          </div>
        </div>
        <div className="main-inicial">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-8 text-center text-uppercase ">
                {t('getReadyMessageMobile1')}<b>{t('getReadyMessageMobile2')}</b>
              </div>
              <div className="board-resumo col-12 mt-5">
                <div className="board-background d-flex align-items-center mb-1">
                  <div className="text pl-2 ">{t('getReadyReservationReference')}</div>
                </div>
                <div className="board-background d-flex align-items-center mb-1">
                  <div className="text pl-2 ">{t('getReadyIDDocument')}</div>
                </div>
                <div className="board-background d-flex align-items-center mb-1">
                  <div className="text pl-2 ">{t('getReadyDriversLicense')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer
        handlePrevClick={() => props.history.goBack()}
        handleNextClick={() => props.history.push('/select-pickup-details')}
      />
    </main>
  )
}

export default withLang(GetReadyPage)